/**Статус операции */
export enum ActionStateEnum {
  /**Инициализация */
  Init = 0,
  /**На подтверждении */
  Confirm = 1,
  /**Успешное исполнение */
  Success = 2,
  /**На исполнении */
  Executing = 3,
  /**Ошибка исполнения */
  Error = 4
}
